import React, { ReactElement } from "react";
import {
  CardContent,
  RadioSelector,
  RadioSelectorItem,
} from "@sellar-io/components";
import { InputLabel } from "@sellar-io/components";

export const IntegrationUpdateContacts = ({
  onChange,
  updateContacts,
  integrationType,
}: {
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  updateContacts: boolean | undefined;
  integrationType: "Xero" | "Quickbooks";
}): ReactElement => {
  return (
    <CardContent className={"flex flex-wrap justify-between gap-2 p-4"}>
      <InputLabel>
        For my existing contacts in {integrationType}, update their details with
        those on the order in Sellar
      </InputLabel>
      <RadioSelector
        onChange={(e) => {
          onChange(e);
        }}
        value={updateContacts ? "yes" : "no"}
        variant="grouped"
      >
        <RadioSelectorItem
          value={"yes"}
          title={"Yes"}
          description={`Sellar will update the contact email and delivery address for your contact in ${integrationType} based on the details supplied with the order from Sellar.`}
        />
        <RadioSelectorItem
          value={"no"}
          title={"No"}
          description={`Sellar will search for and match the customer details from Sellar with those on ${integrationType}; but no details of that customer contact will be changed on ${integrationType}.`}
        />
      </RadioSelector>
    </CardContent>
  );
};
